<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/enTfOK/tc-custom/9781426809668.jpg?1705292796151" alt="This image is the cover for the book His Christmas Bride"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">His Christmas Bride
      </h1>
      <p class="bookDescription body article font2">
        <b>A brokenhearted woman trades romance for career—until a bachelor with a playboy reputation pursues her, intent on a holiday wedding.</b><br/><br/>Blossom was not the type to attract eligible rich men and keep them—her marriage lasted six months before her husband dumped her . . . on Christmas Eve!<br/><br/>So when Zak Hamilton—a billionaire businessman—demanded a date, she was determined not to get involved. But Zak found Blossom’s modesty a challenge. In fact, he decided he would claim her as his bride—by Christmas!
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Helen Brooks
      </h2>
      
      <p class="authorDescription body article">Helen Brooks began writing in 1990 as she approached her 40th birthday! She realized her two teenage ambitions (writing a novel and learning to drive) had been lost amid babies and hectic family life, so set about resurrecting them. In her spare time she enjoys sitting in her wonderfully therapeutic, rambling old garden in the sun with a glass of red wine (under the guise of resting while thinking of course). Helen lives in Northampton, England with her husband and family.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?12d8fe55